import backendFetch from '../../api/backendFetch';

const getStrippedDatasetsFn = async ({ queryKey }) => {
  const {
    account: { name: organizationName, id: organizationId },
    project: { id: projectId },
  } = window.VSS.getWebContext();

  return backendFetch('/actionable-agile/api/datasets/last-loaded', {
    method: 'GET',
    headers: {
      'x-55d-org-id': organizationId,
      'x-55d-org-name': organizationName,
      'x-55d-project-id': projectId,
    },
  }).then((response) => {
    const { data } = response;
    return data.value;
  });
};

export default getStrippedDatasetsFn;
